import { useExperienceController } from '../controllers/ExperienceController';
import SectionWrapper from '../views/components/SectionWrapper';
import ExperienceShimmer from '../views/components/ExperienceShimer';
import { useLanguage } from '../i18n/LanguageContext';

export default function ExperienceView() {
  const { t } = useLanguage();
  const { data, loading, error } = useExperienceController();

  if (loading) return <ExperienceShimmer />;
  if (error) return <div className="alert alert-danger">{t('errors.experience')}</div>;

  return (
    <SectionWrapper id="experience">
      <h2>{t('experience.title')}</h2>

      {data.map(job => (
        <div key={job.id} className="experience-card mb-4" data-aos="fade-up">
          <div className="d-flex align-items-center mb-3">
            {job.logo && (
              <img
                src={job.logo}
                alt={`${job.company} logo`}
                className="company-logo me-3"
              />
            )}
            <div>
              <h5 className="company-name mb-0">{job.company}</h5>
              <p className="designation-name mb-0">{job.designation}</p>
              <small className="date-range">
                {job.start} - {job.end || t('experience.present')}
              </small>
            </div>
          </div>

          <ul className="experience-list">
            {(job.responsibilities || []).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </SectionWrapper>
  );
}
